import { ComboButton, ComboButtonProps } from '@components/combo-button/combo-button';
import { IconDirectionLeft } from '@components/icons/direction-left';
import { IconDirectionRight } from '@components/icons/direction-right';
import { MakePropertiesOptional } from '@utils/types';

export type NavSegmentedButtonsProps = MakePropertiesOptional<ComboButtonProps> & {
  isDisabled?: boolean;
  isBackDisabled?: boolean;
  isForwardDisabled?: boolean;
  onBack?(): void;
  onForward?(): void;
};

export const NavSegmentedButtons = ({
  isDisabled,
  isBackDisabled,
  isForwardDisabled,
  onBack,
  onForward,
  leftButtonProps,
  rightButtonProps,
}: NavSegmentedButtonsProps) => {
  return (
    <ComboButton
      leftButtonProps={{
        iconLeft: <IconDirectionLeft />,
        isDisabled: isDisabled || isBackDisabled,
        onClick: onBack,
        ...leftButtonProps,
      }}
      rightButtonProps={{
        iconLeft: <IconDirectionRight />,
        isDisabled: isDisabled || isForwardDisabled,
        onClick: onForward,
        ...rightButtonProps,
      }}
    />
  );
};
